<div vbUiGridCellKeyboardHandler [headerElement]="eGridHeader" [keyCodes]="['enter', 'space']" (keyPressed)="onKeyPressed($event)">
	<vb-ui-checkbox name="selectAllChkBox" [ngClass]="[
			styles.chkBox,
			isThemed ? styles.themed : styles.notThemed
		]" [accessibilityLabel]="'SelectAll' | translate" [(ngModel)]="isChecked" (ngModelChange)="onCheckboxChange()">
	</vb-ui-checkbox>
</div>

